/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Filename: subscription-edit-grid-component.js
 *
 * Created by randysorensen on 5/17/17.
 */

'use strict';

function SubscriptionEditGridController (_, uiGridConstants, $timeout, $routeParams, $location, SubscriptionsService,
        NavbarUtilService, PaginationService, UtilsService, DynamicPropertiesService, ModalService, SearchFilterService,
        NotificationService, BreadcrumbService, SidebarService) {

    var self = this;

    var canLeaveOrRefresh = function () {
        if (self.editorForm.$dirty) {
            NotificationService.createWarningNotification(
                'You have unsaved changes! ' +
                'Please save or revert your changes before refreshing the subscriptions list.',
                '');
            return false;
        } else {
            return true;
        }
    };


    //======//
    // Data //
    //======//

    var setQueryOptions = function () {
        SubscriptionsService.queryOptions.searchString =
            SubscriptionsService.queryOptions.keywords = $location.search().searchText || null;

        if (self.showDisabled && !self.showEnabled && self.pagingOptions.currentPage > 1) {
            self.pagingOptions.currentPage = 1;
        }

        SubscriptionsService.queryOptions.fetchOffset = self.pagingOptions.pageSize * (self.pagingOptions.currentPage - 1);
        SubscriptionsService.queryOptions.fetchLimit = self.pagingOptions.pageSize;
        SubscriptionsService.queryOptions.includeEnabled = self.showEnabled;
        SubscriptionsService.queryOptions.includeDisabled = self.showDisabled;
    };

    var initializeQuery = function () {
        self.loadingIndicator.show = true;
        setQueryOptions();
    };

    var setContentCategoryBreadcrumbNames = function () {
        self.contentBreadcrumb.location = `/meta/${UtilsService.getPathKeywordFromContentType(SubscriptionsService.contentObject.type)}/edit/${SubscriptionsService.contentObject.id }/categories`;
        self.contentBreadcrumb.name = SubscriptionsService.contentObject.name;
        self.categoryBreadcrumb.name = SubscriptionsService.contentCategoryObject.category.name;
    };

    var addPartnerCustomMetadataColumns = function (partnerId) {
        SubscriptionsService.getPartnerCustomMetadataProperties(partnerId).then(function (props) {
            var sortedProps = _.sortBy(props, [function (metaItem) { return metaItem.displayIndex; }]);
            _.forEach(sortedProps, function (propertyObject) {
                self.gridOptions.columnDefs.push({
                    field: 'metadata.properties.' + propertyObject.name,
                    type: 'string',
                    width: '*',
                    minWidth: 200,
                    cellTemplate: 'components/subscription/gridTemplates/subscription-custom-meta-template.html',
                    displayName: propertyObject.displayName,
                    definition: propertyObject
                });
            });
        });
    };

    var queryCompleted = function (subs) {
        self.subscriptionData = subs;

        self.originalSubscriptionData = _.cloneDeep(self.subscriptionData);
        self.originalSubscriptionDataById = _.keyBy(self.originalSubscriptionData, 'id');
        self.gridOptions.data = self.subscriptionData;
        if (!!self.editorForm && !self.editorForm.$pristine) {
            self.editorForm.$setPristine();
        }
        $timeout(function() {
            self.isCellModified.cache.clear();
        });

        self.gridApi.selection.clearSelectedRows();
        self.gridApi.core.refresh();
        self.loadingIndicator.show = false;
        if (!self.isPartner) {
            setContentCategoryBreadcrumbNames();
        }
    };

    var getSubscriptionData = null;

    var setupGetDataFunction = function () {
        if (self.isPartner) {
            // For partner subscriptions
            getSubscriptionData = function () {
                initializeQuery();
                var partnerId = $routeParams.id;
                SubscriptionsService.getPartnerSubscriptions(partnerId)
                    .then(queryCompleted);
            };
        } else {
            // For content category subscriptions
            getSubscriptionData = function () {
                initializeQuery();
                var contentId = $routeParams.id;
                var contentCategoryId = $routeParams.contentCategoryId;
                SubscriptionsService.getContentCategorySubscriptions(contentId, contentCategoryId)
                    .then(queryCompleted);
            };
        }
    };

    var getChangedSubscriptions = function () {
        var changed = [];
        self.subscriptionData.forEach(function (sub) {
            var original = self.originalSubscriptionDataById[sub.id];
            if (UtilsService.compareBasic(sub, original) !== 0) {
                changed.push(sub);
            }
        });
        return changed;
    };

    var saveSubscriptions = function () {
        self.loadingIndicator.show = true;
        var changed = getChangedSubscriptions();
        SubscriptionsService.updateSubscriptions(changed)
            .then(getSubscriptionData);
    };

    var revertSubscriptions = function () {
        self.subscriptionData = _.cloneDeep(self.originalSubscriptionData);
        self.gridOptions.data = self.subscriptionData;
        self.editorForm.$setPristine();
        // If cache reset without timeout, isCellModified memoizes old modified flag.
        $timeout(function() {
            self.isCellModified.cache.clear();
        });
        self.gridApi.selection.clearSelectedRows();
    };


    //=================//
    // Lifecycle Hooks //
    //=================//

    self.$onInit = function () {
        // Loading indicator
        self.loadingIndicator = {
            backdrop: true,
            show: true,
            title: 'Working',
            message: 'Please wait...'
        };

        // For partner subscriptions grid: augment grid columns
        // with partner custom metadata
        if (self.isPartner) {
            var partnerId = $routeParams.id;
            addPartnerCustomMetadataColumns(partnerId);
        }

        // Initialize pagination
        if ($routeParams.id !== SubscriptionsService.partnerIdForSubscriptionFilter) {
            SubscriptionsService.searchCriteria = null;
            SubscriptionsService.partnerIdForSubscriptionFilter = null;
        }
        self.pagingOptions = PaginationService;
        PaginationService.currentPage = 1;
        DynamicPropertiesService.queryForProperties().then(() => {
            self.crewMemberRoles = DynamicPropertiesService.getPropValueAsList('package.crewMemberRoles');
            PaginationService.pageSize = DynamicPropertiesService.getPropValue(
                self.isPartner ? 'partnerSubscriptions.defaultFetchLimit' : 'contentCategorySubscriptions.defaultFetchLimit',
                UtilsService.constants.DEFAULT_FETCH_LIMIT
            );

            // Get grid/edit data
            setupGetDataFunction();
            getSubscriptionData();

            // Hookup navbar search button
            NavbarUtilService.viewSearchFunction = function () {
                if (canLeaveOrRefresh()) {
                    getSubscriptionData();
                }
            };
        });

        // Freshen the query options
        SubscriptionsService.resetQueryOptions();

        // Tell services that the subscriptions service is in
        // charge of our editor form (so the user can't leave
        // via breadcrumbs or sidebar with a dirty grid)
        BreadcrumbService.editService = SubscriptionsService;
        SidebarService.editService = SubscriptionsService;
    };

    self.$postLink = function () {
        $timeout(function () {
            SubscriptionsService.editorForm = self.editorForm;
        });
    };


    //========//
    // Filter //
    //========//

    var filterPartnerSubscriptions = function () {
        self.pagingOptions.currentPage = 1;
        SubscriptionsService.partnerIdForSubscriptionFilter = $routeParams.id;
        SearchFilterService.updateLocationSearch();
        getSubscriptionData();
    };

    var filterContentSubscriptions = function () {
        self.pagingOptions.currentPage = 1;
        SearchFilterService.updateLocationSearch();
        getSubscriptionData();
    };

    var handleSearchFilterModalCancel = function (cancelMessage) {
        if (cancelMessage === 'setToDefaults') {
            SearchFilterService.resetCriteriaToDefault();
            SubscriptionsService.resetQueryOptions();
            getSubscriptionData();
        }
    };

    NavbarUtilService.viewFilterBtnHandler = function () {
        if (canLeaveOrRefresh()) {
            if (self.isPartner) {
                ModalService.showPartnerSubscriptionFilterModal(filterPartnerSubscriptions, handleSearchFilterModalCancel);
            } else {
                ModalService.showContentCategorySubscriptionFilterModal(
                    SubscriptionsService.contentObject.seasons,
                    SubscriptionsService.contentObject.volumes,
                    filterContentSubscriptions,
                    handleSearchFilterModalCancel
                );
            }
        }
    };


    //================//
    // Event Handlers //
    //================//

    var getCellMemoizeKey = function(sub, field) {
        return `${sub.id}|${field}`;
    };

    // Stop using memoized self.isCellModified() result for all columns of this subscription
    self.invalidateSubscriptionModifiedCache = function(subscription) {
        _.forEach(self.gridOptions.columnDefs, (column) => {
            self.isCellModified.cache.delete(getCellMemoizeKey(subscription, column.field));
        });
    };

    var patchSubscriptionMetadata = function (subscription, changeSet, batchUpdate) {
        if (_.get(subscription, 'metadata.properties')) {
            _.chain(subscription.metadata.properties)
                .keys()
                .filter(propName => !batchUpdate || changeSet.metadata.properties[propName].includeInBatchUpdate)
                .forEach((propName) => {
                    var oldProp = subscription.metadata.properties[propName];
                    var newProp = changeSet.metadata.properties[propName];

                    if (!_.isUndefined(newProp.expression)) {
                        // set an expression
                        delete oldProp.value;
                        oldProp.expression = _.trim(newProp.expression);
                    } else if (!_.isUndefined(newProp.value)) {
                        // set a value
                        delete oldProp.expression;
                        oldProp.value = newProp.value;
                    } else {
                        // blank the field
                        delete oldProp.expression;
                        oldProp.value = '';
                    }
                })
                .value();
        }
    };

    var patchSubscription = function (sub, changeSet) {
        _.forEach(_.keys(changeSet), function (prop) {
            if (prop !== 'metadata') {
                var newValue = changeSet[prop];
                sub[prop] = newValue === null ? {} : newValue;
            }
        });
    };

    var updateSubscriptionHandler = function (subscriptionChangeSet) {
        var wasBatchUpdate = self.gridApi.selection.getSelectedCount() > 1;

        var subs;
        if (wasBatchUpdate) {
            subs = self.gridApi.selection.getSelectedRows();
        } else {
            subs = self.gridOptions.data.filter(function (sub) { return sub.id === subscriptionChangeSet.id; });
        }
        _.forEach(subs, function (sub) {
            patchSubscription(sub, subscriptionChangeSet);

            if (!wasBatchUpdate || self.isPartner) {
                // Partner custom metadata cannot be batch-updated
                // from the content categories screen.
                patchSubscriptionMetadata(sub, subscriptionChangeSet, wasBatchUpdate);
            }
            self.invalidateSubscriptionModifiedCache(sub);
        });

        self.editorForm.$setDirty();
    };

    var handleNewSubscription = function (newSubscriptionData) {
        self.loadingIndicator.show = true;
        SubscriptionsService.createSubscription({
            enabled: true,
            artwork: newSubscriptionData.artwork,
            content: SubscriptionsService.contentObject,
            category: SubscriptionsService.contentCategoryObject.category,
            partner: newSubscriptionData.partner
        }).then(function (newSubscription) {
            getSubscriptionData();
        }, function () {
            NotificationService.createFailureNotification(
                'Subscription already exists.  Please check enabled and disabled subscriptions.', '', true);
            self.loadingIndicator.show = false;
        });
    };

    var openSubscriptionModal = function (subscriptions) {
        ModalService.showContentSubscriptionPropertiesModal(
            subscriptions,
            false,
            self.isPartner,
            updateSubscriptionHandler);
    };


    //======//
    // Grid //
    //======//

    self.seasonVolumeFormat = function (row, col) {
        var formattedDisplayName = col.field.split('.')[0];

        if (row.entity.hasOwnProperty(formattedDisplayName)) {
            var artworkObject = row.entity[formattedDisplayName];
            if (formattedDisplayName === 'artwork' && artworkObject && artworkObject.length > 0) {
                var artworkArray = [];
                _.forEach(artworkObject, function (artwork) {
                    if (artwork.artworkSeasonVolume) {
                        if (artwork.artwork.name.length > 12) {
                            artworkArray.push(artwork.artwork.name.substring(0, 12) + '...(S/V)');
                        } else {
                            artworkArray.push(artwork.artwork.name + ' (S/V)');
                        }
                    } else {
                        artworkArray.push(artwork.artwork.name);
                    }
                });
                return artworkArray.join(', ');
            } else {
                if (row.entity[formattedDisplayName + 'SeasonVolume']) {
                    if (row.entity[formattedDisplayName].name.length > 12) {
                        return row.entity[formattedDisplayName].name.substring(0, 12) + '...(S/V)';
                    } else {
                        return row.entity[formattedDisplayName].name + ' (S/V)';
                    }
                } else {
                    return (row.entity[formattedDisplayName]) ? row.entity[formattedDisplayName].name : '';
                }
            }
        }
    };

    self.getPartnerMetadataField = function (row, col) {
        var metaProp = _.get(row.entity, col.field);
        var pickListItems = _.get(col.colDef, 'definition.picklistItems');
        var uiControlHint = _.get(col.colDef, 'definition.uiControlHint');

        if (uiControlHint === 'CheckboxList') {
            if (metaProp.hasOwnProperty('value') && metaProp.value.length > 0){
                var selectedItems = [];
                _.forEach(metaProp.value, function (value) {
                    selectedItems.push(_.filter(pickListItems, function (item) {
                        return item.id === value;
                    })[0]);
                });
                return _.join(_.map(selectedItems, 'displayName'), ', ');
            } else {
                return '';
            }
        } else if (uiControlHint === 'List') {
            if (metaProp.hasOwnProperty('value')) {
                return _.map(_.filter(pickListItems, function (item) {
                    return item.id === metaProp.value;
                }), 'displayName')[0];
            }
        }
        return metaProp.value || metaProp.expression;
    };

    self.gridApi = null;
    self.searchText = null;

    self.gridColumnDefs = [
        {
            field: 'checkMark',
            width: '50',
            enableSorting: false,
            enableColumnResizing: false,
            cellTemplate: 'components/visual/grid/check-mark-template.html',
            headerCellTemplate: 'components/visual/grid/header-check-mark-row-count-template.html',
            enablePinning: true,
            displayName: '',
            pinnedLeft: true
        },
        {
            partnerOnly: true,
            field: 'content.name',
            type: 'string',
            minWidth: 200,
            displayName: 'Content',
            cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html',
            enablePinning: true,
            pinnedLeft: true,
        },
        {
            partnerOnly: true,
            field: 'category.name',
            type: 'string',
            minWidth: 200,
            displayName: 'Category',
            cellTemplate: 'components/subscription/gridTemplates/subscription-property-default-template.html',
            enablePinning: true,
            pinnedLeft: true,
        },
        {
            contentCategoryOnly: true,
            field: 'partner.name',
            type: 'string',
            minWidth: 250,
            displayName: 'Partner',
            cellTemplate: 'components/subscription/gridTemplates/subscription-property-default-template.html',
            enablePinning: true,
            pinnedLeft: true
        },
        {
            field: 'enabled',
            type: 'string',
            minWidth: 90,
            displayName: 'Enabled',
            cellTemplate: 'components/subscription/gridTemplates/subscription-enabled-template.html'
        },
        {
            seriesOnly: true,
            field: 'seasonSubscription',
            type: 'string',
            minWidth: 70,
            displayName: 'Type',
            cellTemplate: 'components/subscription/gridTemplates/subscription-type-template.html'
        },
        {
            seriesOnly: true,
            field: 'seasons',
            type: 'string',
            minWidth: 140,
            displayName: 'Volumes / Seasons',
            cellTemplate: 'components/subscription/gridTemplates/subscription-seasons-volumes-template.html'
        },
        {
            field: 'preRoll',
            seasonVolumeField: 'preRollSeasonVolume',
            type: 'string',
            minWidth: 170,
            displayName: 'Pre-Roll',
            cellTemplate: 'components/subscription/gridTemplates/branding-season-volume-template.html'
        },
        {
            field: 'postRoll',
            seasonVolumeField: 'postRollSeasonVolume',
            type: 'string',
            minWidth: 170,
            displayName: 'Post-Roll',
            cellTemplate: 'components/subscription/gridTemplates/branding-season-volume-template.html'
        },
        {
            field: 'breakPrePostRoll',
            seasonVolumeField: 'breakPrePostRollSeasonVolume',
            type: 'string',
            minWidth: 170,
            displayName: 'Break Pre/Postroll',
            cellTemplate: 'components/subscription/gridTemplates/branding-season-volume-template.html'
        },
        {
            field: 'nielsenTemplate.name',
            type: 'string',
            minWidth: 232,
            displayName: 'Nielsen Template',
            cellTemplate: 'components/subscription/gridTemplates/subscription-property-default-template.html'
        },
        {
            field: 'nexGuardEnabledFlag',
            type: 'boolean',
            displayName: 'NexGuard Enabled',
            minWidth: 155,
            cellTemplate: 'components/subscription/gridTemplates/subscription-boolean-template.html',
        },
        {
            field: 'watermark',
            seasonVolumeField: 'watermarkSeasonVolume',
            type: 'string',
            minWidth: 180,
            displayName: 'Watermark',
            cellTemplate: 'components/subscription/gridTemplates/branding-season-volume-template.html'
        },
        {
            // aggregate of three fields: watermarkOffsetSeconds, watermarkFadeInSeconds, watermarkFadeOutSeconds
            field: 'watermarkFadeInSeconds',
            type: 'string',
            minWidth: 310,
            displayName: 'Watermark Details (in seconds)',
            cellTemplate: 'components/subscription/gridTemplates/subscription-watermark-details-template.html'
        },
        {
            field: 'intermediateVideoTemplate.name',
            type: 'string',
            minWidth: 232,
            displayName: 'Master Intermediate Template',
            cellTemplate: 'components/subscription/gridTemplates/subscription-property-default-template.html'
        },
        {
            field: 'videoRoles',
            type: 'string',
            minWidth: 250,
            displayName: 'Main Video + Component Role',
            cellTemplate: 'components/subscription/gridTemplates/subscription-component-role-template.html'
        },
        {
            field: 'artwork',
            type: 'string',
            minWidth: 140,
            displayName: 'Artwork',
            cellTemplate: 'components/subscription/gridTemplates/branding-season-volume-template.html'
        },
        {
            field: 'dueDateTemplate.name',
            type: 'string',
            minWidth: 232,
            displayName: 'SLA Template',
            cellTemplate: 'components/subscription/gridTemplates/subscription-property-default-template.html'
        },
        {
            field: 'deliveryEligibilityExpression',
            type: 'string',
            minWidth: 240,
            displayName: 'Delivery Eligibility Expression',
            cellTemplate: 'components/subscription/gridTemplates/subscription-property-default-template.html'
        },
        {
            seriesOnly: true,
            field: 'requiredCrewRoles',
            type: 'string',
            minWidth: 170,
            displayName: 'Required Collaborators',
            cellTemplate: 'components/subscription/gridTemplates/subscription-collaborators-template.html'
        },
        {
            field: 'priorityOffset',
            type: 'string',
            minWidth: 130,
            displayName: 'Priority Offset',
            cellTemplate: 'components/subscription/gridTemplates/subscription-property-default-template.html'
        },
        {
            field: 'territory.name',
            type: 'string',
            minWidth: 100,
            displayName: 'Territory',
            cellTemplate: 'components/subscription/gridTemplates/subscription-property-default-template.html'
        },
        {
            contentCategoryOnly: true,
            field: 'metadata',
            type: 'string',
            minWidth: 240,
            displayName: 'Custom Meta Modified',
            cellTemplate: 'components/subscription/gridTemplates/subscription-custom-meta-change-template.html'
        }];

    var pruneColumnDefs = function () {
        var columnDefs = [];
        self.gridColumnDefs.forEach(function (column) {
            if (self.isPartner && !column.contentCategoryOnly) {
                columnDefs.push(column);
            } else if (!self.isPartner && !column.partnerOnly) {
                var contentType = $location.path().indexOf('movies') > 0 ? 'movies' : 'series';
                if (contentType === 'series' || !column.seriesOnly) {
                    columnDefs.push(column);
                }
            }
        });
        return columnDefs;
    };

    self.getSubscriptionStatus = function (sub) {
        if (!sub.enabled) {
            return 'subscription-disabled';
        }
        if (sub.adHocPackageId) {
            return 'subscription-adhoc';
        }
        if ((!!sub.seasons && sub.seasons.length > 0) || (!!sub.volumes && sub.volumes.length > 0)) {
            return 'subscription-partial';
        } else {
            return 'subscription-all';
        }
    };

    self.gridOptions = {
        rowSelection: false,
        enableRowHeaderSelection: false,
        enableSelectAll: true,
        enableColumnResizing: true,
        enablePaginationControls: false,
        enableSorting: true,
        enableColumnMenus: false,
        enableFullRowSelection: true,
        enableHorizontalScrollbar: uiGridConstants.ALWAYS,
        enableVerticalScrollbar: uiGridConstants.ALWAYS,
        multiSelect: true,
        columnDefs: pruneColumnDefs(),
        onRegisterApi: function (gridApi) {
            self.gridApi = gridApi;
        }
    };

    self.rowDoubleClick = function (row) {
        var selectedCount = self.gridApi.selection.getSelectedCount();
        var selectedRows = self.gridApi.selection.getSelectedRows();
        var multiSelect = selectedCount > 1;
        var batchUpdate = false;

        if (multiSelect) {
            // Multiple rows selected... is the double-clicked
            // row one of them?
            batchUpdate = !!_.find(
                selectedRows,
                function (subscription) {
                    return subscription.id === row.entity.id;
                });
        }

        var selectedSubscriptionsList;

        if (batchUpdate) {
            selectedSubscriptionsList = _.cloneDeep(selectedRows);
            openSubscriptionModal(selectedSubscriptionsList);
        } else {
            var editSelectedSubscription = function () {
                selectedSubscriptionsList = [ _.cloneDeep(row.entity) ];
                openSubscriptionModal(selectedSubscriptionsList);
            };

            if (multiSelect) {
                ModalService.showMessageModal({
                    messageText: 'You have one or more subscriptions selected, but have ' +
                    'chosen to edit a single unselected subscription.',
                    title: 'Update Unselected Subscription',
                    windowClass: 'confirm-modal-lg',
                    showOK: true,
                    showCancel: true,
                    pullCancelLeft: true,
                }, editSelectedSubscription);
            } else {
                editSelectedSubscription();
            }
        }
    };

    self.preventRowDefault = function (event) {
        event.preventDefault();
        event.stopImmediatePropagation();
    };

    self.toggleRows = function (event) {
        if (self.gridApi.selection.selectAll) {
            self.gridApi.selection.clearSelectedRows(event);
            self.gridApi.selection.selectAll = false;
        } else {
            self.gridApi.selection.selectAllVisibleRows(event);
            self.gridApi.selection.selectAll = true;
        }
    };

    var isCellModified = function (row, col) {
        let originalSubscription = self.originalSubscriptionDataById[row.entity.id];
        let result = false;

        if (col.field === 'seasons') {
            let subTypeName = (row.entity.seasonSubscription) ? 'seasons' : 'volumes';
            let seasonOrVolume = (row.entity.seasonSubscription) ? 'season' : 'volume';
            if (originalSubscription[subTypeName].length === row.entity[subTypeName].length) {
                result = !_.chain(originalSubscription[subTypeName])
                    .differenceBy(row.entity[subTypeName], seasonOrVolume +'.id')
                    .isEmpty()
                    .value();
            } else {
                result = true;
            }

        } else if (col.field === 'metadata') {
            result = UtilsService.compareBasic(
                _.get(originalSubscription, 'metadata.properties'),
                _.get(row.entity, 'metadata.properties')
            ) !== 0;

        } else {
            result = UtilsService.compareBasic(
                _.get(originalSubscription, col.field),
                _.get(row.entity, col.field)
            ) !== 0;
            if (col.colDef.seasonVolumeField) {
                let result_sv = UtilsService.compareBasic(
                    _.get(originalSubscription, col.colDef.seasonVolumeField),
                    _.get(row.entity, col.colDef.seasonVolumeField)
                ) !== 0;
                result = result || result_sv;
            }
        }

        return result;
    };

    self.isCellModified = _.memoize(isCellModified, function(row, col) {
        return getCellMemoizeKey(row.entity, col.field);
    });

    //=================//
    // Toolbar Buttons //
    //=================//

    var isNotPristine = function () {
        return self.editorForm && !self.editorForm.$pristine;
    };

    self.toolbarButtonDefs = [
        {
            label: 'New',
            enabled: function () { return !self.isPartner && self.editorForm.$pristine; },
            onClick: function () {
                if (canLeaveOrRefresh()) {
                    ModalService.showNewSubscriptionModal(
                        SubscriptionsService.contentCategoryObject.category.type.id,
                        SubscriptionsService.contentCategoryObject.category.id,
                        SubscriptionsService.contentObject.id,
                        SubscriptionsService.contentObject.network.id,
                        handleNewSubscription);
                }
            }
        },
        {
            label: 'Save',
            enabled: function () {
                return isNotPristine();
            },
            onClick: function () {
                ModalService.showMessageModal({
                    messageText: 'You are about to SAVE all pending subscription changes. ' +
                        'Are you sure you wish to continue?',
                    title: 'Save Subscriptions',
                    showOK: true,
                    okText: 'Yes',
                    pullCancelLeft: true,
                    cancelText: 'No',
                    windowClass: 'confirm-modal-sm'
                }, saveSubscriptions);
            }
        },
        {
            label: 'Revert',
            enabled: function () {
                return isNotPristine();
            },
            onClick: function () {
                ModalService.showMessageModal({
                    messageText: 'You are about to REVERT all pending subscription changes. ' +
                    'Are you sure you wish to continue?',
                    title: 'Revert Subscriptions',
                    showOK: true,
                    okText: 'Yes',
                    pullCancelLeft: true,
                    cancelText: 'No',
                    windowClass: 'confirm-modal-sm'
                }, revertSubscriptions);
            }
        },
        {
            label: 'Close',
            enabled: function () { return false; },
            onClick: null
        },
    ];


    //===========================//
    // Toolbar Filter Checkboxes //
    //===========================//

    self.showEnabled = true;
    self.showDisabled = false;

    var showEnabledCB = {
        label: 'Show Enabled',
        isChecked: self.showEnabled,
    };

    var showDisabledCB = {
        label: 'Show Disabled',
        isChecked: self.showDisabled,
    };

    showEnabledCB.onUpdate = function (newValue) {
        if (canLeaveOrRefresh()) {
            // unchecking "Show Enabled" will automatically check "Show Disabled"
            showEnabledCB.isChecked = newValue;
            self.showEnabled = newValue;
            if (!newValue) {
                showDisabledCB.isChecked = true;
                self.showDisabled = true;
            }
            getSubscriptionData();
        } else {
            showEnabledCB.isChecked = !newValue;
        }
    };

    showDisabledCB.onUpdate = function (newValue) {
        if (canLeaveOrRefresh()) {
            // unchecking "Show Disabled" will automatically check "Show Enabled"
            showDisabledCB.isChecked = newValue;
            self.showDisabled = newValue;
            if (!newValue) {
                showEnabledCB.isChecked = true;
                self.showEnabled = true;
            }
            getSubscriptionData();
        } else {
            showDisabledCB.isChecked = !newValue;
        }
    };

    self.toolbarCheckboxDefs = [
        showEnabledCB,
        showDisabledCB
    ];


    //============//
    // Pagination //
    //============//

    self.onPaginationChanged = function () {
        getSubscriptionData();
    };

    self.paginationPageSizeChanged = function () {
        self.pagingOptions.currentPage = 1;
        self.onPaginationChanged();
    };

    self.paginationPrevPageHandler = function () {
        --self.pagingOptions.currentPage;
        self.onPaginationChanged();
    };

    self.paginationNextPageHandler = function () {
        ++self.pagingOptions.currentPage;
        self.onPaginationChanged();
    };

    self.paginationDefs = {
        paginationPrevPageHandler: self.paginationPrevPageHandler,
        paginationNextPageHandler: self.paginationNextPageHandler,
        paginationPageSizeChanged: self.paginationPageSizeChanged,
        paginationJumpToPageHandler: self.onPaginationChanged,
        disabled: function () {
            return self.editorForm.$dirty;
        },
        pagingOptions: PaginationService,
    };
}

angular
.module('prism-ui.components')
.component('subscriptionEditGrid', {
    templateUrl: 'components/subscription/subscription-edit-grid-template.html',
    controller: SubscriptionEditGridController,
    bindings: {
        isPartner: '<',
        contentBreadcrumb: '<',
        categoryBreadcrumb: '<'
    }
})
.filter('volumeSeasonFilter', function () {
    return function (value, grid) {
        if (grid.row.entity.content.type !== 'Series') {
            return 'N/A';
        }

        var type = (grid.row.entity.seasonSubscription) ? ' Seasons' : ' Volumes';
        if (value.length === 0) {
            return 'All' + type;
        } else if (value.length === 1) {
            return value.length + type.slice(0, -1);
        } else {
            return value.length + type;
        }
    };
})
.filter('artworkAssetFilter', function () {
    return function (value) {
        if (value.length === 1) {
            return '1 Artwork Asset';
        } else if (value.length > 1) {
            return value.length + ' Artwork Assets';
        } else {
            return '';
        }
    };
})
.filter('videoRolesFilter', function (_) {
    return function (videoRoles) {
        return _.map(videoRoles,'role.name').join(', ');
    };
});
